import React, { useEffect, useState } from 'react';
import { getPosts } from '../services/api';
import PostView from '../views/Posts';

const PostComponent = () => {
   

    const [data1, setData] = useState([]);

    useEffect(() => {
      
    }, []);   
    return <PostView data={data1} />;
   
};

export default PostComponent;
